import { Component, OnInit } from '@angular/core';
import { OktaAuth, Tokens } from '@okta/okta-auth-js';
// @ts-ignore
import * as OktaSignIn from '@okta/okta-signin-widget';
import {environment} from "../../../../environments/environment";
import {NGXLogger} from "ngx-logger";

const DEFAULT_ORIGINAL_URI = window.location.origin;
const CALLBACK_PATH = '/login/callback';
const HOST = window.location.host;
const REDIRECT_URI = `https://${HOST}`;
const REDIRECT_SIGNOUT_URI = `${environment.okta_signout_path}`

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  signIn: any;

  /**
   * Constructor
   * @param oktaAuth Okta Authorization instance
   * @param logger Logger instance.
   */
  constructor(public oktaAuth: OktaAuth,
              private logger: NGXLogger,) {
    this.logger.debug("Okta signout URL:" + REDIRECT_SIGNOUT_URI);
    let baseurl = environment.okta_issuer.split('/oauth2')[0];
    this.logger.debug("okta baseurl=" + baseurl);

    this.signIn = new OktaSignIn({
      /**
       * Note: when using the Sign-In Widget for an OIDC flow, it still
       * needs to be configured with the base URL for your Okta Org. Here
       * we derive it from the given issuer for convenience.
       */
      baseUrl: baseurl,
      clientId: environment.okta_client_id,
      postLogoutRedirectUri: REDIRECT_SIGNOUT_URI,
      redirectUri: REDIRECT_URI,
      logo: '../../../assets/img/Logo.png',
      i18n: {
        en: {
          'primaryauth.title': 'Sign in to TCB',
        },
      },
      authClient: oktaAuth,
      useInteractionCodeFlow: false,
    });
  }

  /**
   * Called to initialize the object
   */
  ngOnInit() {
    // When navigating to a protected route, the route path will be saved as the `originalUri`
    // If no `originalUri` has been saved, then redirect back to the app root
    const originalUri = this.oktaAuth.getOriginalUri();
    if (!originalUri || originalUri === DEFAULT_ORIGINAL_URI) {
      this.oktaAuth.setOriginalUri('/');
    }

    this.signIn.showSignInToGetTokens({
      el: '#sign-in-widget',
      scopes:  ['openid', 'profile', 'email'],
    }).then((tokens: Tokens) => {
      // Remove the widget
      this.signIn.remove();

      // In this flow the redirect to Okta occurs in a hidden iframe
      this.oktaAuth.handleLoginRedirect(tokens);
    }).catch((err: any) => {
      // Typically due to misconfiguration
      this.logger.error("Failed Login" + JSON.stringify(err));
      throw err;
    });
  }

  /**
   * Called when object is destroyed.
   */
  ngOnDestroy() {
    this.signIn.remove();
  }

}
